/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TransferLineItem,
  TransferLineItem$inboundSchema,
  TransferLineItem$Outbound,
  TransferLineItem$outboundSchema,
} from "./transferlineitem.js";

/**
 * An optional collection of line items for a transfer.
 *
 * @remarks
 * When line items are provided, their total plus sales tax must equal the transfer amount.
 */
export type TransferLineItems = {
  /**
   * The list of line items.
   */
  items: Array<TransferLineItem>;
};

/** @internal */
export const TransferLineItems$inboundSchema: z.ZodType<
  TransferLineItems,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(TransferLineItem$inboundSchema),
});
/** @internal */
export type TransferLineItems$Outbound = {
  items: Array<TransferLineItem$Outbound>;
};

/** @internal */
export const TransferLineItems$outboundSchema: z.ZodType<
  TransferLineItems$Outbound,
  z.ZodTypeDef,
  TransferLineItems
> = z.object({
  items: z.array(TransferLineItem$outboundSchema),
});

export function transferLineItemsToJSON(
  transferLineItems: TransferLineItems,
): string {
  return JSON.stringify(
    TransferLineItems$outboundSchema.parse(transferLineItems),
  );
}
export function transferLineItemsFromJSON(
  jsonString: string,
): SafeParseResult<TransferLineItems, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TransferLineItems$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TransferLineItems' from JSON`,
  );
}
